import {NodeName} from "../flavour/openlexia/nodeName.mjs";

export class NodeIterator {

    constructor(rootNode) {
        this.openNodes = []
        this.currentParentNode = rootNode
    }

    addOpenNode(node) {
        this.currentParentNode.children.push(node)
        this.openNodes.push(node)
        this.currentParentNode = node
    }

    addClosedNode(node) {
        node.close()
        this.currentParentNode.children.push(node)
    }

    hasOpenNode(nodeName) {
        return this.indexOfLastOpen(NodeName.EMPHASIS_UNDEFINED) !== null;
    }

    indexOfLastOpen(nodeName) {
        for (let i = this.openNodes.length - 1; i >= 0; i--) {
            let node = this.openNodes[i]
            if (!node || node.isClosed()) continue
            if (node.name === nodeName) return i
        }

        return null
    }

    closeNodeAtIndex(openNodeIndex) {
        const openNode = this.openNodes[openNodeIndex]
        if(!openNode) return

        openNode.close()
        this.removeFromOpenNodes(openNodeIndex);

        // set parent as parent of this closed node
        this.currentParentNode = openNode.parent
    }

    removeFromOpenNodes(openNodeIndex) {
        this.openNodes.splice(openNodeIndex, 1)
    }

    cancelNodeAtIndex(openNodeIndex) {
        const openNode = this.openNodes[openNodeIndex]

        openNode.cancel()
        this.removeFromOpenNodes(openNodeIndex);

        // set parent as parent of this closed node
        this.currentParentNode = openNode.parent
    }

}